(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-full-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.heroFullBannerTooltipPositioning) {
    window.heroFullBannerTooltipPositioning = true;

    const tooltipHotspotSelector = '.hero-full-banner__hotspot';
    const imageSelector = '.hero-full-banner__image-block';
    const desktopPointer = window.matchMedia('(min-width: 750px) and (any-hover: hover)');
    let cursorHotspot;
    let pointer;
    let frame = 0;

    const resetCursor = (hotspot) => {
      hotspot?.removeAttribute('data-cursor-positioned');
      hotspot?.style.removeProperty('--hero-hotspot-x');
      hotspot?.style.removeProperty('--hero-hotspot-y');
    };

    const positionCursor = () => {
      frame = 0;
      if (!cursorHotspot?.isConnected || cursorHotspot.open) return;
      const bounds = cursorHotspot.closest(imageSelector).getBoundingClientRect();
      const x = Math.max(22, Math.min(pointer.x - bounds.left, bounds.width - 22));
      const y = Math.max(22, Math.min(pointer.y - bounds.top, bounds.height - 22));
      cursorHotspot.style.setProperty('--hero-hotspot-x', `${x}px`);
      cursorHotspot.style.setProperty('--hero-hotspot-y', `${y}px`);
      cursorHotspot.setAttribute('data-cursor-positioned', '');
    };

    const positionDesktopTooltip = (hotspot) => {
      hotspot.removeAttribute('data-tooltip-positioned');
      if (window.matchMedia('(max-width: 749px)').matches || !hotspot.open) return;
      const tooltip = hotspot.querySelector('.hero-full-banner__tooltip');
      const imageBounds = hotspot.closest(imageSelector).getBoundingClientRect();
      const headerBounds = document.querySelector('#header-component')?.getBoundingClientRect();
      const gap = 16;
      const left = Math.max(gap, imageBounds.left + gap);
      const right = Math.min(document.documentElement.clientWidth - gap, imageBounds.right - gap);
      const top = Math.max(gap, imageBounds.top + gap, (headerBounds?.bottom ?? 0) + gap);
      const bottom = Math.min(window.innerHeight - gap, imageBounds.bottom - gap);
      hotspot.style.setProperty('--hero-tooltip-available-width', `${Math.max(0, right - left)}px`);
      hotspot.style.setProperty('--hero-tooltip-available-height', `${Math.max(0, bottom - top)}px`);
      const bounds = tooltip.getBoundingClientRect();
      const anchor = hotspot.getBoundingClientRect();
      let x = bounds.left;
      let y = bounds.top;

      if (hotspot.dataset.tooltipPosition === 'above' && y < top && anchor.bottom + 8 + bounds.height <= bottom) {
        y = anchor.bottom + 8;
      } else if (hotspot.dataset.tooltipPosition === 'below' && y + bounds.height > bottom && anchor.top - 8 - bounds.height >= top) {
        y = anchor.top - 8 - bounds.height;
      } else if (hotspot.dataset.tooltipPosition === 'left' && x < left && anchor.right + 8 + bounds.width <= right) {
        x = anchor.right + 8;
      } else if (hotspot.dataset.tooltipPosition === 'right' && x + bounds.width > right && anchor.left - 8 - bounds.width >= left) {
        x = anchor.left - 8 - bounds.width;
      }

      x = Math.max(left, Math.min(x, right - bounds.width));
      y = Math.max(top, Math.min(y, bottom - bounds.height));
      hotspot.style.setProperty('--hero-tooltip-x', `${x - anchor.left}px`);
      hotspot.style.setProperty('--hero-tooltip-y', `${y - anchor.top}px`);
      hotspot.setAttribute('data-tooltip-positioned', '');
    };

    document.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse' || !desktopPointer.matches) return;
      const image = event.target.closest(imageSelector);
      const hotspot = image?.querySelector(tooltipHotspotSelector);
      if (!hotspot || hotspot.open || hotspot.querySelector('summary').matches(':focus-visible')) return;
      if (cursorHotspot !== hotspot) {
        if (cursorHotspot && !cursorHotspot.open) resetCursor(cursorHotspot);
        cursorHotspot = hotspot;
      }
      pointer = { x: event.clientX, y: event.clientY };
      if (!frame) frame = requestAnimationFrame(positionCursor);
    });

    document.addEventListener('pointerout', (event) => {
      const image = event.target.closest(imageSelector);
      if (!image || (event.relatedTarget instanceof Node && image.contains(event.relatedTarget))) return;
      const hotspot = image.querySelector(tooltipHotspotSelector);
      if (hotspot !== cursorHotspot) return;
      cancelAnimationFrame(frame);
      frame = 0;
      if (!hotspot.open) resetCursor(hotspot);
      cursorHotspot = undefined;
    });

    document.addEventListener('focusin', (event) => {
      if (!event.target.matches('.hero-full-banner__hotspot-trigger:focus-visible')) return;
      cancelAnimationFrame(frame);
      frame = 0;
      resetCursor(event.target.closest(tooltipHotspotSelector));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(`${tooltipHotspotSelector}[open]`).forEach((hotspot) => {
        if (hotspot.querySelector('.hero-full-banner__tooltip').contains(document.activeElement)) {
          hotspot.querySelector('summary').focus({ preventScroll: true });
        }
        hotspot.open = false;
      });
    });

    const positionMobileTooltip = (hotspot) => {
      hotspot.removeAttribute('data-tooltip-mobile-positioned');
      if (!window.matchMedia('(max-width: 749px)').matches || !hotspot.open) return;
      const viewport = window.visualViewport;
      const gap = 16;
      const left = (viewport?.offsetLeft ?? 0) + gap;
      const right = (viewport?.offsetLeft ?? 0) + (viewport?.width ?? document.documentElement.clientWidth) - gap;
      const headerBounds = document.querySelector('#header-component')?.getBoundingClientRect();
      const top = Math.max((viewport?.offsetTop ?? 0) + gap, (headerBounds?.bottom ?? 0) + gap);
      const bottom = (viewport?.offsetTop ?? 0) + (viewport?.height ?? window.innerHeight) - gap;
      hotspot.style.setProperty('--hero-tooltip-mobile-width', `${Math.max(0, right - left)}px`);
      hotspot.style.setProperty('--hero-tooltip-mobile-height', `${Math.max(0, bottom - top)}px`);
      const bounds = hotspot.querySelector('.hero-full-banner__tooltip').getBoundingClientRect();
      const anchor = hotspot.getBoundingClientRect();
      const x = left + (right - left - bounds.width) / 2;
      const y = Math.max(top, Math.min(anchor.top + anchor.height / 2 - bounds.height / 2, bottom - bounds.height));
      hotspot.style.setProperty('--hero-tooltip-mobile-x', `${x - anchor.left}px`);
      hotspot.style.setProperty('--hero-tooltip-mobile-y', `${y - anchor.top}px`);
      hotspot.setAttribute('data-tooltip-mobile-positioned', '');
    };

    const positionAllMobileTooltips = (root = document) => {
      root.querySelectorAll(tooltipHotspotSelector).forEach(positionMobileTooltip);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => positionAllMobileTooltips(), { once: true });
    } else {
      positionAllMobileTooltips();
    }

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('.hero-full-banner__tooltip-close');
      if (closeButton) {
        event.preventDefault();
        const hotspot = closeButton.closest(tooltipHotspotSelector);
        hotspot.querySelector('summary').focus({ preventScroll: true });
        hotspot.open = false;
        return;
      }

      const image = event.target.closest(imageSelector);
      const clickedHotspot = image?.querySelector(tooltipHotspotSelector);

      document.querySelectorAll(`${tooltipHotspotSelector}[open]`).forEach((hotspot) => {
        if (hotspot !== clickedHotspot) hotspot.open = false;
      });

      if (!clickedHotspot || event.target.closest('.hero-full-banner__tooltip')) return;
      event.preventDefault();
      cancelAnimationFrame(frame);
      frame = 0;
      clickedHotspot.querySelector('summary').focus({ preventScroll: true });
      if (event.detail > 0 && desktopPointer.matches && !clickedHotspot.open) {
        cursorHotspot = clickedHotspot;
        pointer = { x: event.clientX, y: event.clientY };
        positionCursor();
      }
      clickedHotspot.open = !clickedHotspot.open;
      positionMobileTooltip(clickedHotspot);
      positionDesktopTooltip(clickedHotspot);
    });

    let scrollFrame = 0;
    const scheduleTooltipPositioning = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        document.querySelectorAll(`${tooltipHotspotSelector}[open]`).forEach((hotspot) => {
          positionDesktopTooltip(hotspot);
          positionMobileTooltip(hotspot);
        });
      });
    };

    window.addEventListener('scroll', scheduleTooltipPositioning, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleTooltipPositioning, { passive: true });
    window.visualViewport?.addEventListener('scroll', scheduleTooltipPositioning, { passive: true });

    window.addEventListener('resize', () => {
      cancelAnimationFrame(frame);
      frame = 0;
      document.querySelectorAll(tooltipHotspotSelector).forEach((hotspot) => {
        resetCursor(hotspot);
        positionDesktopTooltip(hotspot);
      });
      positionAllMobileTooltips();
    });

    document.addEventListener('shopify:section:load', (event) => {
      positionAllMobileTooltips(event.target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
